/**
 * EmpresaChip (rc20+) — chip pequeño con icono Building2 + nombre de empresa.
 * Auto-oculto si solo existe UNA empresa en el sistema (evita ruido visual
 * para ISPs que operan con una sola razón social).
 */
import { Building2 } from "lucide-react";
import { useEmpresasMap } from "./useEmpresasMap";

type Props = {
  empresaId: number | null | undefined;
  /** Si true, fuerza mostrar incluso si solo hay 1 empresa */
  alwaysShow?: boolean;
  /** Variante de tamaño */
  size?: "sm" | "md";
};

export function EmpresaChip({ empresaId, alwaysShow = false, size = "sm" }: Props) {
  const { multiEmpresa, nombreOf, isLoading } = useEmpresasMap();
  if (isLoading) return null;
  if (!multiEmpresa && !alwaysShow) return null;
  if (empresaId == null) return null;

  const cls = size === "sm"
    ? "inline-flex items-center gap-1 rounded bg-muted px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground"
    : "inline-flex items-center gap-1.5 rounded bg-muted px-2 py-1 text-xs font-medium text-muted-foreground";

  return (
    <span className={cls} title={`Empresa: ${nombreOf(empresaId)}`}>
      <Building2 size={size === "sm" ? 10 : 12} />
      <span>{nombreOf(empresaId)}</span>
    </span>
  );
}
